import React, { useState } from "react";
import { X, AlertTriangle, RotateCcw } from "lucide-react";
import { supabase } from "../../../Services/supabaseClient";
import "./fixedAssets.css";

export default function ReverseDepreciationRunModal({
  run,
  onClose,
  onReversed,
}) {
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function reverse() {
    setErr("");
    setBusy(true);

    try {
      const ok = window.confirm(
        `Reverse depreciation for period ${String(run.period_month).slice(
          0,
          7
        )}?\n\nThis will create reversal journals in your ledger (no deletes).`
      );
      if (!ok) return;

      const { data: sessionData } = await supabase.auth.getSession();
      const token = sessionData?.session?.access_token;
      if (!token) throw new Error("Not authenticated.");

      const fnUrl = `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/fixed-assets-reverse-depreciation`;

      const res = await fetch(fnUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ run_id: run.id, reversal_notes: notes }),
      });

      const json = await res.json();
      if (!res.ok)
        throw new Error(json?.error || "Failed to reverse depreciation run.");

      onReversed?.(json);
    } catch (e) {
      setErr(e.message || "Error");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 14,
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        className="fa-panel"
        style={{ width: "min(760px, 100%)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{ display: "flex", justifyContent: "space-between", gap: 10 }}
        >
          <div>
            <div style={{ fontSize: 18, fontWeight: 900 }}>
              Reverse Depreciation Run
            </div>
            <div style={{ opacity: 0.8, fontSize: 13, marginTop: 4 }}>
              Period: <b>{String(run.period_month).slice(0, 7)}</b>
            </div>
          </div>
          <button className="fa-icon-btn" onClick={onClose} title="Close">
            <X size={16} />
          </button>
        </div>

        <div className="fa-card" style={{ marginTop: 12 }}>
          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
            <AlertTriangle size={18} />
            <div>
              <div style={{ fontWeight: 800 }}>
                This creates reversal journals
              </div>
              <div style={{ opacity: 0.8, marginTop: 4, fontSize: 13 }}>
                We will not delete anything. Your ledger stays auditable.
              </div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 10 }}>
          <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 6 }}>
            Reversal notes (optional)
          </div>
          <textarea
            className="fa-textarea"
            rows={3}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>

        {err && (
          <div style={{ marginTop: 10, color: "#ffb4b4", fontSize: 13 }}>
            {err}
          </div>
        )}

        <div
          className="fa-actions"
          style={{ marginTop: 12, justifyContent: "flex-end" }}
        >
          <button className="fa-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="fa-btn fa-btn-primary"
            onClick={reverse}
            disabled={busy}
          >
            <RotateCcw size={16} /> {busy ? "Reversing…" : "Reverse Run"}
          </button>
        </div>
      </div>
    </div>
  );
}
